import type { DemoId } from "@/demos/types";

export const ANALYTICS_EVENT_NAME = "risingpixel:analytics";

export type AnalyticsEvent =
  | { name: "experience_opened"; demoId: DemoId }
  | { name: "cta_clicked"; demoId: DemoId; ctaId: "primary" };
